import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const FOOTER_LINKS = {
  Services: [
    { label: "Journalist Outreach", path: "/services/journalist-outreach" },
    { label: "Newswire Distribution", path: "/services/newswire-distribution" },
    { label: "Guaranteed Placements", path: "/services/guaranteed-placements" },
    { label: "Find Your Fit", path: "/services/find-your-fit" },
  ],
  Company: [
    { label: "About", path: "/about" },
    { label: "How It Works", path: "/how-it-works" },
    { label: "Guides", path: "/guides" },
    { label: "Resellers & Partners", path: "/resellers" },
    { label: "Contact", path: "/contact" },
  ],
  Resources: [
    { label: "FAQ", path: "/faq" },
    { label: "Newsroom", path: "/newsroom" },
    { label: "Editorial Calendar", path: "/editorial-calendar" },
  ],
  Legal: [
    { label: "Terms & Conditions", path: "/terms" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Refund Policy", path: "/terms#return-and-refund-policy" },
  ],
};

export default function Footer() {
  return (
    <footer className="glass-footer relative">
      <Container className="py-14 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-9 mb-11">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Logo className="mb-3" imgClassName="h-7" />
            <p className="text-[13px] text-[#8e8e96] leading-relaxed max-w-[220px]">
              Global press release distribution and digital PR.
            </p>
          </div>

          {/* Link Columns */}
          {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
            <div key={heading}>
              <h2 className="font-mono text-[10px] uppercase tracking-[0.12em] text-[#8e8e96] mb-4">{heading}</h2>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      data-track-label={link.path === "/resellers" ? "apply_reseller" : undefined}
                      data-track-section={link.path === "/resellers" ? "footer" : undefined}
                      className="text-[13px] text-[#6c6c74] hover:text-[#1c1c20] transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-7 border-t border-[rgba(28,28,32,0.07)] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[12px] text-[#8e8e96] whitespace-nowrap">
            © {new Date().getFullYear()} Digital24. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://www.linkedin.com/company/digital24dubai/" target="_blank" rel="noopener noreferrer" className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#8e8e96] hover:text-[#1c1c20] transition-colors">LinkedIn</a>
            <a href="https://www.instagram.com/digital24_global/" target="_blank" rel="noopener noreferrer" className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#8e8e96] hover:text-[#1c1c20] transition-colors">Instagram</a>
            <a href="mailto:info@digital24.com" className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#8e8e96] hover:text-[#1c1c20] transition-colors">Email</a>
          </div>
        </div>
      </Container>
    </footer>
  );
}